import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-mobile-dictionary',
  templateUrl: './mobile-dictionary.component.html',
  styleUrls: ['./mobile-dictionary.component.scss']
})
export class MobileDictionaryComponent {
  @ViewChild('content') content: ElementRef;

  constructor(private modalService: NgbModal) { }

  public open() {
    const modalOptions: NgbModalOptions = {
      size: 'lg',
      windowClass: 'full-modal m-dictionary',
    };

    this.modalService.open(this.content, modalOptions);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-dictionary/mobile-dictionary.component.ts